import axiosInstance from "./axiosInstance";

export const apiGet = async (url, params = {}) => {
  try {
    const response = await axiosInstance.get(url, { params });
    return response.data;
  } catch (error) {
    console.error("GET error:", error);
    throw error;
  }
};

export const apiPost = async (url, data) => {
  try {
    const response = await axiosInstance.post(url, data);
    return response;
  } catch (error) {
    // Throw structured error so it's easier to handle later
    if (error.response) {
      const serverMsg = error.response.data?.message ||
      error.response.data?.error ||
      error.response.data?.msg ||
      JSON.stringify(error.response.data) || 
      'Server error';
      throw new Error(serverMsg);
      
    } else if (error.request) {
      throw new Error('No response from server. Check your network.');
    } else {
      throw new Error(error.message || 'Unexpected error');
    }
  }
};

export const apiPut = async (url, data) => {
  try {
    const response = await axiosInstance.put(url, data);
    return response;
  } catch (error) {
    // Throw structured error so it's easier to handle later
    if (error.response) {
      const serverMsg = error.response.data?.message ||
      error.response.data?.error ||
      error.response.data?.msg ||
      JSON.stringify(error.response.data) || 
      'Server error';
      throw new Error(serverMsg);
      
    } else if (error.request) {
      throw new Error('No response from server. Check your network.');
    } else {
      throw new Error(error.message || 'Unexpected error');
    }
  }
};

// export const apiPut = async (url, data) => {
//   try {
//     const response = await axiosInstance.put(url, data);
//     return response.data;
//   } catch (error) {
//     console.error("PUT error:", error);
//     throw error;
//   }
// };

export const apiDelete = async (url) => {
  try {
    const response = await axiosInstance.delete(url);
    return response.data;
  } catch (error) {
    console.error("DELETE error:", error);
    throw error;
  }
};

export const apiPostFormData = async (url, formData) => {
  try {
    const response = await axiosInstance.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    // Same structured error handling as apiPost
    if (error.response) {
      const serverMsg =
        error.response.data?.message ||
        error.response.data?.error ||
        error.response.data?.msg ||
        JSON.stringify(error.response.data) ||
        "Server error";

      throw new Error(serverMsg);
    } else if (error.request) {
      throw new Error("No response from server. Check your network.");
    } else {
      throw new Error(error.message || "Unexpected error");
    }
  }
};

export const apiDownload = async (url) => {
  return axiosInstance.get(url, {
    responseType: "blob", // 👈 VERY IMPORTANT
  });
};

